import React from "react";
import { Helmet } from "react-helmet-async";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Blogsection from "../Page-section/Blogsection";
import "../styles/Blogsection.css";

function Blog() {
  return (
    <div>
      <Helmet>
        <title>Digital Marketing Blog | SEO Tips to Grow Your Business</title>
        <meta
          name="description"
          content="Explore expert SEO tips, digital marketing strategies & growth hacks to boost traffic, leads & sales. Stay updated with latest trends , free consultation today!"
        />
        <meta
          name="keywords"
          content="AI marketing automation, SEO services 2026, lead generation, business automation, sales funnel optimization, web development, UI UX design, content writing, branding services, digital marketing trends, predictive analytics, conversion rate optimization"
        />
        <meta
          property="og:title"
          content="Master SEO, Digital Marketing & AI - Latest 2026 Updates"
        />
        <meta
          property="og:description"
          content="Expert insights on AI-powered marketing, SEO strategies, lead generation, and web development trends."
        />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://empowerweb.in/blog" />
        <meta property="og:url" content="https://empowerweb.in/blog" />

        <meta
          property="og:image"
          content="https://empowerweb.in/static/media/Empower.1d6b0218c2d70eaf298eeb6e28190aa7.svg"
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Empowerweb Digital Marketing Strategies & Growth Boost"
        />
        <meta
          name="twitter:description"
          content="Empowerweb blog shares expert digital marketing strategies, smart development tips, and proven ideas to boost brand growth, traffic, and online business success."
        />
        <meta
          name="twitter:image"
          content="https://empowerweb.in/static/media/Empower.1d6b0218c2d70eaf298eeb6e28190aa7.svg"
        />
      </Helmet>
      <Header />
      <Navbar />
      <main id="main-content">
        <Blogsection />
      </main>
      <Footer />
    
    </div>
  );
}

export default Blog;
